import Vue from 'vue';
import clientGroupTransformer from './../../transformers/clientGroup';

const success = (resolve) => {
  // Vue.router.push({
  //   name: 'clientGroups.index',
  // });
  resolve();
};

const failed = (errors, reject) => {
  reject(clientGroupTransformer.fetch(errors));
};

export default clientGroup => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('client_groups', clientGroup)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/client-group/store.js